/**
 * Transforms raw data into options format for select components
 * @param {Array} data - Raw data array
 * @param {Object} config - Configuration for transformation
 * @returns {Array} Transformed options array
 */
export const transformToOptions = (data, config = {}) => {
  const { 
    idField = 'id',
    nameField = 'name',
    valueField = null, // Field to use as value, defaults to nameField
    additionalFields = []
  } = config;

  return data.map(item => {
    const option = {
      id: item[idField],
      name: item[nameField],
      value: item[valueField || nameField] // Use valueField if provided, otherwise use nameField
    };

    // Copy all original data to the option
    Object.keys(item).forEach(key => {
      if (!option[key]) {
        option[key] = item[key];
      }
    });

    // Add any additional fields specified
    additionalFields.forEach(field => {
      if (!option[field]) {
        option[field] = item[field];
      }
    });

    return option;
  });
};

/**
 * Groups kanban data by stages
 * @param {Array} items - Items to group
 * @param {Array} stages - Available stages
 * @returns {Object} Grouped data by stage
 */
export const groupKanbanDataByStage = (items, stages) => {
  const groupedData = {};

  stages.forEach(stage => {
    const stageItems = items.filter(item => item.stage === stage);
    groupedData[stage] = {
      items: stageItems,
      count: stageItems.length
    };
  });

  return groupedData;
};

/**
 * Updates item stage in kanban board
 * @param {Array} items - Current items
 * @param {number} itemId - ID of item to update
 * @param {string} newStage - New stage value
 * @returns {Array} Updated items array
 */
export const updateItemStage = (items, itemId, newStage) => {
  return items.map(item => {
    if (item.id === itemId) {
      return { ...item, stage: newStage };
    }
    return item;
  });
}; 